import Connections from '../../connections';
import {
  observable,
} from 'mobx';
import {
  getCurrentUser,
  getAllCountries, 
} from '../../axios/requests';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import { RequestStatus } from 'mobx-store';

export class CountryStore {
    @observable managedCountries: ICountry[] = [];
    @observable countryList: ICountry[] = [];

  @observable isLoadingManagedCountries = false;

  @observable getManagedCountriesRequestStatus: RequestStatus = RequestStatus.IDLE; 

  constructor() {}

  public async getUserManagedCountries(resource?: string, operation?: string): Promise<void> {
    try {
      // This function will be used to get managed countries per resource and operation.
      this.isLoadingManagedCountries = true;
      this.getManagedCountriesRequestStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(getCurrentUser);
      this.managedCountries = response.data.countries;
      this.isLoadingManagedCountries = false;
      this.getManagedCountriesRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getManagedCountriesRequestStatus = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }
    public async getAllCountries(): Promise<void> {
      try {
        // This function will be used to get managed countries per resource and operation.
        this.isLoadingManagedCountries = true;
        const response = await Connections.wadiDeglaAxios.httpGet(getAllCountries);
        this.countryList = response.data;
        this.isLoadingManagedCountries = false;
      } catch (error) {
        return Promise.reject(error);
      }
    }
}
